<template>
  <div class="card mb-4">
    <div class="card-body">
      <h5>{{ noteReturn.note_ref }}</h5>
      <br />
      <p>
        Date de création :
        <b v-if="noteReturn.created_at">
          {{ getDate(noteReturn.created_at) }}
        </b>
        |
        <b v-if="noteReturn.magasin">
          {{ noteReturn?.magasin?.market_name }}
        </b>
        (<b>{{ noteReturn.for_name }}</b
        >)
        <template v-if="noteReturn.city_return">
          ({{ noteReturn.city_return }})
        </template>
      </p>
    </div>
  </div>

  <div class="card mb-4" v-if="noteReturn.statut == 0">
    <div class="card-header pb-2">
      <h5>Scan code suivi</h5>
    </div>
    <div class="card-body">
      <form @submit.prevent="SearchColis">
        <div class="row align-items-end">
          <div class="col-md-9">
            <div class="form-group">
              <label>Code Suivi :</label>
              <input
                class="form-control"
                placeholder="Code Suivi"
                type="text"
                v-model="codeColis"
              />
            </div>
          </div>
          <div class="col-md-3">
            <button type="submit" class="btn btn-success mb-2">
              <i class="flaticon-plus"></i>
            </button>
          </div>
          <div class="col-12">
            <hr />
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card mb-4" v-if="noteReturn.statut == 0">
    <div class="card-header pb-2">
      <h3>List des nouveaux colis</h3>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div class="col-md-9">
          <div class="input-group">
            <!-- <rangedate-picker
              style="width: 100%"
              ref="myInput"
              v-model="date_filter"
              format="YYYY-MM-DD"
              i18n="EN"
              :presetRanges="presetRanges"
              :captions="captions"
            ></rangedate-picker> -->
          </div>
        </div>
        <!-- <div class="col-md-3 d-flex">
          <button class="btn btn-warning mr-2" @click="FilterColis">
            <i class="flaticon-filter"></i> Filtrer
          </button>
          <button class="btn btn-danger" @click="Removefilter()">
            <i class="flaticon-close"></i>
            Annuler
          </button>
        </div> 
        <div class="col-12">
          <hr />
        </div>-->
        <div
          v-if="auth.can('ADD_BR_C')"
          class="col-md-6 mb-2 d-flex align-items-center"
        >
          <button
            v-if="noteReturn.statut == 0"
            class="btn btn-success mr-2"
            @click="AddNewColis"
          >
            Ajouter
          </button>
          <v-select
            v-model="users1.per_page"
            :options="[10, 50]"
            :clearable="false"
            class="mx-2"
            @input="getRows1()"
          />
          <label class="mb-0">{{ users1.total }} entités</label>
        </div>
        <div class="col-md-6 mb-2">
          <div class="form-group mb-0 d-flex justify-content-end">
            <input
              class="form-control"
              placeholder="Chercher"
              type="text"
              v-model="users1.searchTerm"
              @input="getRows1()"
            />
          </div>
        </div>
      </div>

      <vue-good-table
        :columns="columns"
        :rows="rows1"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @select-all="onSelectAll"
        @selected-rows-change="selectionChanged"
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template v-slot:table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <template v-if="props.row.delivered_by != 0">
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg':
                    globalStore.globalHelper('DELIVERED').code_color,
                }"
              >
                {{ globalStore.globalHelper("DELIVERED").name }}
              </div>
            </template>
            <template
              v-if="
                props.row.delivered_by == 0 &&
                (props.row.status_second || props.row.status_second != null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg': globalStore.globalHelper(
                    props.row.status_second
                  ).code_color,
                }"
              >
                {{ globalStore.globalHelper(props.row.status_second).name }}
              </div>
            </template>
            <template
              v-if="
                props.row.delivered_by == 0 &&
                (!props.row.status_second || props.row.status_second == null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': props.row.code_color }"
              >
                {{ props.row.s_name }}
              </div>
            </template>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'received_time'">
            <span class="text-nowrap" v-if="props.row.received_time">
              {{ getDate(props.row.received_time) }}
            </span>
            <span class="text-nowrap" v-else> </span>
          </template>
          <template v-else-if="props.column.field === 'liv_fees'">
            <template v-if="props.row.status == 'DELIVERED'">
              <b>{{ props.row.liv_fees_livred }}</b> DH
            </template>
            <template v-if="props.row.status == 'REFUSE'">
              <b>{{ props.row.liv_fees_refused }} </b> DH
            </template>
          </template>
          <template v-else-if="props.column.field === 'total'">
            <template v-if="props.row.status == 'DELIVERED'">
              <b>{{ props.row.price - props.row.liv_fees_livred }} </b>
              DH
            </template>
            <template v-if="props.row.status == 'REFUSE'">
              <b>{{ 0 - props.row.liv_fees_refused }} </b> DH
            </template>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row mt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users1"
            :offset="9"
            @paginate="getRows1"
          />
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-4">
    <div class="card-header pb-2">
      <h5>List des colis ajoutés</h5>
    </div>
    <div class="card-body">
      <div class="row mb-3">
        <div
          v-if="auth.can('ADD_BR_C')"
          class="col-md-6 mb-2 d-flex align-items-center"
        >
          <button
            v-if="noteReturn.statut == 0"
            class="btn btn-danger mr-2"
            @click="RemoveNewColis"
          >
            Supprimer
          </button>
          <v-select
            v-model="users2.per_page"
            :options="[10, 25]"
            :clearable="false"
            class="mx-2"
            @input="getRows2()"
          />
          <label class="mb-0">sur {{ users2.total }} entité </label>
        </div>
        <div class="col-md-6 mb-2">
          <div class="form-group mb-0 d-flex justify-content-end">
            <input
              class="form-control"
              placeholder="Chercher"
              type="text"
              @input="getRows2()"
              v-model="users2.searchTerm"
            />
          </div>
        </div>
      </div>
      <vue-good-table
        :columns="columns"
        :rows="rows2"
        :select-options="{
          selectOnCheckboxOnly: true,
          enabled: true,
          clearSelectionText: 'Annuler',
          selectionText: 'Colis Sélectionés',
          disableSelectInfo: true,
          selectAllByGroup: true,
        }"
        @select-all="onSelectAllColis"
        @selected-rows-change="selectionChangedColis"
        responsive
      >
        <template #emptystate>
          <center>Aucune entrées correspondants trouvés</center>
        </template>
        <template #table-row="props">
          <template v-if="props.column.field === 'code'">
            <h6 class="text-warning" v-if="props.row.replace == 1">
              {{ props.row.code }}
              <i class="flaticon-refresh"></i>
            </h6>
            <h6 class="text-info" v-else-if="props.row.partial == 1">
              {{ props.row.code }}
              <i class="flaticon-corner-down-left"></i>
            </h6>
            <h6 v-else>
              {{ props.row.code }}
            </h6>
          </template>
          <template v-else-if="props.column.field === 'status'">
            <template v-if="props.row.delivered_by != 0">
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg':
                    globalStore.globalHelper('DELIVERED').code_color,
                }"
              >
                {{ globalStore.globalHelper("DELIVERED").name }}
              </div>
            </template>
            <template
              v-if="
                props.row.delivered_by == 0 &&
                (props.row.status_second || props.row.status_second != null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{
                  '--dynamic-bg': globalStore.globalHelper(
                    props.row.status_second
                  ).code_color,
                }"
              >
                {{ globalStore.globalHelper(props.row.status_second).name }}
              </div>
            </template>
            <template
              v-if="
                props.row.delivered_by == 0 &&
                (!props.row.status_second || props.row.status_second == null)
              "
            >
              <div
                class="rounded-pill fs-13 badge text-bg-black custom-badge"
                :style="{ '--dynamic-bg': props.row.code_color }"
              >
                {{ props.row.s_name }}
              </div>
            </template>
          </template>
          <template v-else-if="props.column.field === 'price'">
            <b>{{ props.row.price }}</b> DH
          </template>
          <template v-else-if="props.column.field === 'received_time'">
            <span class="text-nowrap" v-if="props.row.received_time">
              {{ getDate(props.row.received_time) }}
            </span>
            <span class="text-nowrap" v-else> </span>
          </template>
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
      </vue-good-table>
      <div class="row mt-3">
        <div class="col-md-6"></div>
        <div class="col-md-6">
          <PaginatorContent
            :pagination="users2"
            :offset="9"
            @paginate="getRows2"
          />
        </div>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useAuthStore } from "@/stores/auth";
import { useGlobalStore } from "@/stores/global";
import api from "@/utils/axios";
import moment from "moment";
import { onMounted } from "vue";
import { reactive, ref, getCurrentInstance } from "vue";
import { defineComponent } from "vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  setup() {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;
    const globalStore = useGlobalStore();
    const route = useRoute();
    const instance = getCurrentInstance();

    const AgenciesList = ref([]);
    const ClientsList = ref([]);
    const AgencyStockList = ref([]);
    const isLoader = ref(true);
    const searchTerm1 = ref("");
    const searchTerm2 = ref("");
    const pageLength = ref(10);
    const pageLength2 = ref(10);

    const columns = [
      {
        label: "Code Suivi",
        field: "code",
      },
      {
        label: "Client",
        field: "customer_name",
      },
      {
        label: "Date de réception",
        field: "received_time",
      },
      {
        label: "Ville",
        field: "city_name",
      },
      {
        label: "Status",
        field: "status",
      },
      {
        label: "Prix",
        field: "price",
      },
    ];

    const SelectedRows = ref([]);
    const SelectedNewRows = ref([]);
    const codeColis = ref("");
    const refReception = ref("");
    const rows1 = ref([]);
    const rows2 = ref([]);
    const noteReturn = ref<any>({});

    const users = reactive({
      searchSDate: "",
      searchEDate: "",
    });
    const date_filter = ref("");

    const users1 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    const users2 = reactive({
      searchTerm: "",
      total: 0,
      per_page: 10,
      from: 1,
      to: 0,
      current_page: 1,
    });

    function getDate(value: string) {
      return moment.utc(String(value)).format("YYYY-MM-DD HH:mm");
    }

    function SearchColis() {
      let data = new FormData();
      data.append("user_id", user?.id?.toString() ?? "");
      data.append("code_colis", codeColis.value);
      data.append("ref_note", String(route.params.refNote));
      data.append("note_type", "2");

      api
        .post(`/api/auth/Rn_C_ScanColis`, data)
        .then((res) => {
          codeColis.value = "";
          if (res.data.message == "success") {
            const audio = new Audio("/sound.mp3");
          audio.play();
            showToast("Succès\nColis bien ajouté", "success");
            getData();
          } else if (res.data.message == "not exist") {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Erreur\nVous pouvez pas ajouter ce colis", "error");
          } else if (res.data.message == "error note") {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Erreur\nVous pouvez pas ajouter à ce bon", "error");
          } else if (res.data.message == "parcel exit") {
            const audio = new Audio("/erro.mp3");
            audio.play();
            showToast("Erreur\nColis déjà existe dans ce bon !", "error");
          }
        })
        .catch(() => {
          showToast("Erreur\nSomething went wrong! Please try again", "error");
        });
    }

    function onSelectAll(params: any) {
      SelectedRows.value = params.selectedRows;
    }

    function selectionChanged(params: any) {
      SelectedRows.value = params.selectedRows;
    }

    function onSelectAllColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }

    function selectionChangedColis(params: any) {
      SelectedNewRows.value = params.selectedRows;
    }

    function getData() {
      isLoader.value = true;
      api
        .get(`/api/auth/show_bon_rn_ag`, {
          params: { ref: route.params.refNote },
        })
        .then((res) => {
          noteReturn.value = res.data.Note;
        })
        .finally(() => {
          isLoader.value = false;
        });
      getRows1();
      getRows2();
    }

    function getRows1(page = 1) {
      users1.current_page = page;
      api
        .get(
          `/api/auth/list_coli_cstrn?searchTerm=${users1.searchTerm}&page=${users1.current_page}&per_page=${users1.per_page}`,
          {
            params: {
              ref: route.params.refNote,
              searchSDate: users.searchSDate,
              searchEDate: users.searchEDate,
            },
          }
        )
        .then((res) => {
          rows1.value = res.data.users.data;
          Object.assign(users1, res.data.users);
        });
    }

    function getRows2(page = 1) {
      users2.current_page = page;
      api
        .get(
          `/api/auth/list_coli_in_cstrn?searchTerm=${users2.searchTerm}&page=${users2.current_page}&per_page=${users2.per_page}&type=2`,
          {
            params: { ref: route.params.refNote },
          }
        )
        .then((res) => {
          rows2.value = res.data.users.data;
          Object.assign(users2, res.data.users);
        });
    }

    function AddNewColis() {
      if (!SelectedRows.value.length) {
        showToast("Erreur\nVous pouvez pas ajouter à ce bon", "error");
      } else {
        let data = new FormData();
        data.append("UserID", user?.id?.toString() ?? "");
        data.append("colis", JSON.stringify(SelectedRows.value));
        data.append("note_ref", String(route.params.refNote));
        data.append("note_type", "2");
        api.post(`/api/auth/Add_colis_to_rnc`, data).then((res) => {
          if (res.data.message == "success") {
            const audio = new Audio("/sound.mp3");
          audio.play();
            showToast("Succès\nAjouté avec succès", "success");
            getData();
          } else {
            showToast(
              "Erreur\nSomething went wrong! Please try again",
              "error"
            );
          }
        });
      }
    }

    function RemoveNewColis() {
      if (!SelectedNewRows.value.length) {
        showToast("Erreur\nVous pouvez pas supprimer de ce bon", "error");
      } else {
        let data = new FormData();
        data.append("UserID", user?.id?.toString() ?? "");
        data.append("colis", JSON.stringify(SelectedNewRows.value));
        data.append("note_ref", String(route.params.refNote));
        api.post(`/api/auth/remove_colis_rnc`, data).then((res) => {
          if (res.data.message == "success") {
           const audio = new Audio("/sound.mp3");
          audio.play();
            showToast("Succès\nSupprimé avec succès", "success");
            getData();
          } else {
            showToast(
              "Erreur\nSomething went wrong! Please try again",
              "error"
            );
          }
        });
      }
    }

    function convert(str: string) {
      var date = new Date(str),
        mnth = ("0" + (date.getMonth() + 1)).slice(-2),
        day = ("0" + date.getDate()).slice(-2);
      return [date.getFullYear(), mnth, day].join("-");
    }

    function FilterColis() {
      console.log("date_filter");
      //   const myInput = instance?.proxy?.$refs?.myInput;
      //   users.searchSDate =
      //     myInput?.dateRange?.start === undefined
      //       ? ""
      //       : convert(myInput.dateRange.start);
      //   users.searchEDate =
      //     myInput?.dateRange?.end === undefined
      //       ? ""
      //       : convert(myInput.dateRange.end);
    }

    function Removefilter() {
      //   const myInput = instance?.proxy?.$refs?.myInput;
      //   if (myInput) myInput.dateRange = {};
      users.searchSDate = users.searchEDate = "";
      date_filter.value = "";
    }

    onMounted(async () => {
      getData();
    });

    return {
      getDate,
      SearchColis,
      onSelectAll,
      selectionChanged,
      onSelectAllColis,
      selectionChangedColis,
      getData,
      getRows1,
      getRows2,
      AddNewColis,
      RemoveNewColis,
      convert,
      FilterColis,
      Removefilter,
      AgenciesList,
      ClientsList,
      AgencyStockList,
      isLoader,
      searchTerm1,
      searchTerm2,
      pageLength,
      pageLength2,
      columns,
      SelectedRows,
      SelectedNewRows,
      codeColis,
      refReception,
      rows1,
      rows2,
      noteReturn,
      users,
      date_filter,
      users1,
      users2,
      auth,
      user,
      globalStore,
    };
  },
});
</script>
